import { useContext } from 'react';
import { useCookies } from 'react-cookie';
import FeatureFlagsContext from '../store/featureFlagsState';

const useFeatureEnabled = (featureSlug) => {
  const [cookies] = useCookies(['local_features', 'designation', 'memberships', 'projectType']);
  const { featureFlags } = useContext(FeatureFlagsContext);

  const localFeatures = Array.isArray(cookies?.local_features) ? cookies.local_features : [];

  const globalFeatures = Array.isArray(featureFlags) ? featureFlags : [];

  const designationFeatures = Array.isArray(cookies?.designation?.features)
    ? cookies.designation.features
    : [];

  const isFeatureLocallyEnabled = localFeatures.some((feature) => feature.slug === featureSlug);

  const isFeatureEnabledGlobally = globalFeatures.some(
    (feature) => feature.slug === featureSlug && feature.enabled
  );

  const enterpriseFeatures = designationFeatures.some((feature) => feature.slug === featureSlug);

  const isFeatureEnabled =
    isFeatureLocallyEnabled || enterpriseFeatures || isFeatureEnabledGlobally;

  return { isFeatureEnabled };
};

export default useFeatureEnabled;
